import type { PriorityItem } from '@/types/gmb';

export default function PrioritySection({ priorities }: { priorities: PriorityItem[] }) {
  const top = [...priorities].sort((a, b) => a.rank - b.rank).slice(0, 3);
  const isEmpty = top.length === 0;

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 pt-12 md:px-8 md:pt-14">
      <div className="mb-5 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-teal-50 text-teal-700">
          <i className="ri-focus-3-line" />
        </span>
        <h2 className="text-lg font-bold text-slate-900 md:text-[1.5rem]">Top 3 改善優先</h2>
      </div>

      {isEmpty ? (
        <div className="rounded-lg border border-dashed border-slate-300 bg-slate-50/60 p-6 text-center text-sm text-slate-500">
          尚無改善優先項目，待健診結果產生後顯示。
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {top.map((item) => (
            <div key={item.metricCode} className="rounded-lg border border-slate-200 bg-white p-5">
              <div className="flex items-center justify-between">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-900 text-sm font-bold text-white">
                  {item.rank}
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-teal-50 px-2.5 py-1 text-xs font-medium text-teal-700">
                  <i className="ri-arrow-up-line" />
                  最多可提升 {item.potentialGain} 分
                </span>
              </div>
              <p className="mt-4 text-xs font-medium text-slate-400">{item.metricCode}</p>
              <h3 className="mt-1 text-base font-bold text-slate-900">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.recommendation}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}